import { FC, ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';
import { Checkbox } from 'components/Form/Checkbox/Checkbox';

type FilterOptionRowProps = {
  type: 'checkbox' | 'radio';
  name: string;
  selected: boolean;
  onSelect: () => void;
  children: string;
  testId?: string;
  // Rendered below the row's label, so clicks on it do not toggle the option.
  footer?: ReactNode;
};

export const FilterOptionRow: FC<FilterOptionRowProps> = ({
  type,
  name,
  selected,
  onSelect,
  children,
  testId,
  footer,
}) => (
  <li className={cn('hover:bg-gray-100', selected ? 'bg-gray-100' : undefined)}>
    {/* The label wraps the control and spans the row, so a click anywhere on the row toggles it. */}
    <label className="flex cursor-pointer items-start gap-3 px-4 py-2 text-sm font-medium text-gray-700">
      {type === 'checkbox' ? (
        <Checkbox checked={selected} onChange={onSelect} data-testid={testId} />
      ) : (
        <span className="flex h-5 items-center">
          <input
            type="radio"
            name={name}
            checked={selected}
            onChange={onSelect}
            data-testid={testId}
            className="size-4 border-gray-300 text-gray-700 focus:border-gray-300 focus:ring-0 focus:ring-offset-0 focus-visible:ring-2 focus-visible:ring-procuros-green-500 focus-visible:ring-offset-2"
          />
        </span>
      )}
      {children}
    </label>
    {footer}
  </li>
);
